var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("home-header"),
      _vm.featuredCampaigns.length
        ? _c("product-group", {
            staticClass: "mt-3 container mx-auto lg_mt-4 xl_mt-5",
            attrs: {
              text: "featured",
              "utm-source": "featured",
              affiliate: _vm.config.AFFILIATE_ID,
              campaigns: _vm.featuredCampaigns,
              "currency-info": _vm.currencyInfo
            }
          })
        : _vm._e(),
      _c("home-curated"),
      _c("collection", {
        attrs: {
          "utm-source": "homepage-hobbies",
          category: _vm.hobbiesCategory,
          links: _vm.hobbyLinks,
          campaigns: _vm.hobbiesCampaigns
        }
      }),
      _c("join-now-banner"),
      _c("shop-by-category"),
      _c("collection", {
        attrs: {
          "utm-source": "homepage-occupation",
          category: _vm.jobsCategory,
          links: _vm.jobsLinks,
          campaigns: _vm.occupationsCampaigns
        }
      }),
      _c("home-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }